<template>
  <div>
    <div v-bind:id="id" class="map__container" style=""></div><!-- height:800px  -->
  </div>
</template>
<script>
import $ from "jquery";
import { createPopupClass } from "../../_Popup";
import { MAP_STYLE } from "../../../js/_map-style"
const Popup = createPopupClass()

export default {
  data() {
    return {
      mapOptions: {
        zoom: 8,
        disableDefaultUI: true,
        panControl: false,
        center: {
          lat: 38.6530169,
          lng: -90.3835463
        },
        styles: MAP_STYLE
      }
    };
  },
  props: {
    id: String,
    locations: Array|String,
    markerIcon: {
      type: [String, null],
      default: null
    },
    markerIconActive: {
      type: [String, null],
      default: null
    }
  },
  computed: {
    locationPoints() {
        return typeof this.locations == 'string' ? JSON.parse(this.locations) : this.locations
    }
  },
  methods: {
    contactListHtml(contactList) {
      if (contactList.length == 0) {
        return ""
      }

      let html = `<ul class="location__contact-list">`;
      if (contactList.hasOwnProperty('tel')) {
        let phones = contactList.tel;
        phones.items.forEach(phone => {
          html += `<li><abbr title="${phones.label}">${phones.abbr}</abbr>. <a href="${phone.url}">${phone.title}</a></li>`
        })
      }
      if (contactList.hasOwnProperty('fax')) {
        let faxes = contactList.fax;
        faxes.items.forEach(fax => {
          html += `<li><abbr title="${faxes.label}">${faxes.abbr}</abbr>. ${fax.title}</li>`
        })
      }
      html += `</u>`;

      return html;
    },
    getLocationAddressString: function(location) {
      if (location.hasOwnProperty("address")) {
        location = location.address;
      }
      let addressString = "";

      if (location.hasOwnProperty("street_address")) {
        addressString += location.street_address;
      }
      if (location.hasOwnProperty("city")) {
        addressString += " " + location.city;
      }
      if (location.hasOwnProperty("state")) {
        addressString += " " + location.state;
      }
      if (location.hasOwnProperty("postal_code")) {
        addressString += ", " + location.postal_code;
      }
      if (location.hasOwnProperty("country")) {
        addressString += " - " + location.country;
      }

      return addressString.length > 0 ? addressString : false;
    },
    getLocationWindow(location) {
      return `<div class="location">
                  <span class="location__title">${location.title}</span>
                  <address class="location__content">
                      <span>${location.address.street_address}</span><br/>
                      <span>${location.address.city}, ${location.address.state} ${location.address.postal_code}</span>
                  </address>
                  ${this.contactListHtml(location.contactList)}
              </div>`
    },
    addMarkerToMap(map, location, mapBounds, Markers, popups, padding) {
        let marker = new google.maps.Marker({
            map,
            position: location.position,
            icon: Markers.base
        });

        let content = this.getLocationWindow(location)

        const popup = new Popup(marker, content);
        popup.setMap(map);
        popups.push(popup)

        marker.addListener("click", function(event) {
        if (popup.isVisible()) {
            popup.Hide();
            this.setIcon(Markers.base)
            map.panTo(mapBounds.getCenter())
            map.panBy(0, (-1 * padding.top)/2)
        } else {
            popups.forEach(dialog => {
            dialog.Hide()
            dialog.marker.setIcon(Markers.base)
            })
            popup.Show();
            this.setIcon(Markers.active)
            map.panTo(marker.position)
            map.panBy(0, (-1 * padding.top)/2)
        }
        });

        mapBounds.extend(marker.position);
        map.fitBounds(mapBounds, padding);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const map = new google.maps.Map(
        document.getElementById(this.id),
        this.mapOptions
      );
      const mapBounds = new google.maps.LatLngBounds();
      const geocoder = new google.maps.Geocoder();
      const locations = this.locationPoints
      const locationPositions = [];
      const Markers = {
        active: this.markerIconActive,
        base: this.markerIcon
      }

      new Promise((resolve, reject) => {
        const payload = {}
        let topPadding = $(".map__content").outerHeight() + 30
        let padding = {top: topPadding}
        const popups = []
        locations.forEach((location, index) => {
          let addressString = this.getLocationAddressString(location);
          let hasCoordinates = !!location.position.lat && !!location.position.lng

          if (hasCoordinates) {
            this.addMarkerToMap(map, location, mapBounds, Markers, popups, padding)
          } else if (addressString) {
            geocoder.geocode(
              {
                address: addressString
              },
              (results, status) => {
                if (status == google.maps.GeocoderStatus.OK) {
                  const address = results[0];
                  location.position = address.geometry.location
                  this.addMarkerToMap(map, location, mapBounds, Markers, popups, padding)
                } else {
                  console.error(
                    "Geocode was not successful for the following reason : " +
                      status
                  );
                }
                }
            );
          }
          resolve(payload);
        });
      })
      .catch(error => console.error(error));
    });
  }
};
</script>
<style lang="scss">
@import "../../../scss/theme/variables.scss";
.location {
  &__title {
    font-weight: 700;
    color: $color-blue;
    font-size: 16px;
    margin-bottom: 20px;
    display: block;
  }
  &__content,
  &__contact-list {
    font-size: 12px;
    line-height: 26px;
    margin-bottom: 0;
  }
  &__contact-list {
    list-style: none;
    padding-left: 0;
    margin-left: 0;
  }
}
.popup {
  &-container {
    cursor: auto;
    position: absolute;
    width: 340px;
    transition: opacity 350ms cubic-bezier(0.215, 0.61, 0.355, 1);

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }
    &.active {
      opacity: 1;
      pointer-events: auto;
    }
  }
  &-bubble-anchor {
    position: absolute;
    width: 100%;
    bottom: /* TIP_HEIGHT= */ 8px;
    left: 20px;
    background-color: rgba(white, 0.95);
    padding: 2rem;
    border-bottom: solid 3px $color-apple;

    &::after {
      content: "";
      position: absolute;
      bottom: -3px;
      left: 0;
      transform: translate(-100%, 0);
      width: 14px;
      height: 3px;
      background-color: $color-apple;
    }
  }
}
</style>